/**
 * @description 工具库
 */
import { env } from "@/env"
import { getCookie } from "mpfe-utils"

export default {
    /**
     * @description 获取SSP请求主机名
     */
    getSSPHost: function() {

        var _hostMap = {
            "test": "//d1.m.sohu.com",
            "pre": "//ssp-pre.aty.sohu.com",
            "prod": "//v2.sohu.com",
        }

        return _hostMap[env]
    },
    /**
     * @description 获取Wap端域名
     */
    getWapSohuHost: function(){
        var _hostMap = {
            //测试环境地质为http
            "test": "http://test-m.sohu.com",
            //预上线和线上为https
            "pre": "https://pre-m.sohu.com",
            "prod": "https://m.sohu.com",
        }
        return _hostMap[env]
    },
    getPcSohuHost: function(){
        var _hostMap = {
            "test": "https://test-www.focus.cn",
            "pre": "https://www.focus.cn",
            "prod": "https://www.focus.cn",
        }

        return _hostMap[env]
    },
    getFocusWapSohuHost: function(){
        var _hostMap = {
            "test": "http://m.focus-test.cn",
            "pre": "https://m.focus.cn",
            "prod": "https://m.focus.cn",
        }

        return _hostMap[env]
    },
    /**
     * 判断浏览器是不是ie11
     */
    isIE11: function(){
        var u = window.navigator.userAgent.toLocaleLowerCase()
        var ie11 = /(trident)\/([\d.]+)/
        b = u.match(ie11);
        if(b)return true
        return false
    },
    openWindow: (function () {
        var childWindow;
        var openWindow = function (url, width, height, fn) {
            if (childWindow !== undefined) {
                return;
            }
            var h = typeof window.screenX != "undefined" ?
                window.screenX : window.screenLeft,
                e = typeof window.screenY != "undefined" ?
                window.screenY : window.screenTop,
                m = typeof window.outerWidth != "undefined" ?
                window.outerWidth : document.documentElement.clientWidth,
                j = typeof window.outerHeight != "undefined" ?
                window.outerHeight : (document.documentElement.clientHeight -
                    22),
                left = parseInt(h + ((m - width) / 2), 10),
                top = parseInt(e + ((j - height) / 2.5), 10);
            childWindow = window.open(url, '',
                'alwaysRaised=yes, left=' + left + ', top=' +
                top + ', width=' + width + ', height=' +
                height + ', scrollbars=no, z-look=yes');

            var timer;
            var response = function () {
                window.clearInterval(timer);
                childWindow = undefined;
                fn && fn();
            };
            timer = window.setInterval(function () {
                try {
                    if (childWindow.closed === false) {
                        return;
                    } else {
                        response();
                    }
                } catch (ex) {
                    response();
                }
            }, 500);
        };
        return openWindow;
    })(),

    // 每周更换一个字符，匹配上suv最后一位, 加载sentry
    isImportSentry: function() {
        const suv = getCookie('SUV');
        const suvLastLetter = suv && suv.slice(-1);

        const chars = [...'0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz']; // 定义包含数字0-9，字母A-Z，a-z的数组
        
        const today = new Date(); // 获取当前日期
        const startOfYear = new Date(today.getFullYear(), 0, 1); // 今年1月1日
        const dayOfYear = Math.floor((today - startOfYear + 86400000) / 86400000); // 计算今年的第几天，86400000为一天的毫秒数
        const weekOfYear = Math.ceil(dayOfYear / 7); // 计算是今年的第几周
        const index = (weekOfYear - 1) % chars.length; // 计算当前周对应的字符索引，使用取模操作重新循环
        // 返回对应的字符 ?= suv最后一位
        return chars[index] == suvLastLetter
    }
}

// 隐藏dom
export const hideDom = function(selectName) {
    const dom = document.querySelector(selectName)
    if(dom) {
        dom.style.display = 'none'
    }
}